<template>
  <div>
    <!-- 篩選 -->
    <div class="card filter-card">
      <div class="card-body">
        <div v-if="!filterVisible" class="filter-toggle-icon" @click="toggleFilter">
          <i class="fa fa-search"></i>
        </div>
        <div v-else>
          <div class="filter-header">
              <button class="btn btn-toggle" @click="toggleFilter"><i class="fa fa-times"></i></button>
          </div>
          <div class="row input-row">
            <div class="col-md-9">
              <label for="name">Subgroup name</label>
              <input type="text" id="name" class="form-control" v-model="subgroup_name" />
            </div>
            <div class="col-md-3 mt-2 d-flex justify-content-end mt-4">
              <button class="btn btn-reset" @click="resetFilters">Reset</button>
              <button class="btn btn-search" @click="search">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DataTable -->
    <div class="card mt-4" v-if="paginatedData != ''">
      <div class="card-body">
        <div class="table-responsive signal-table">
          <table class="table table-hover">
            <thead>
              <tr>
                <th 
                  @click="sortTable('created_at')" 
                  :class="{'sortable col-name': true, 'active': subgroupStore.sort_by === 'created_at'}">
                  <span>Created &nbsp;</span>
                  <i v-if="subgroupStore.sort_by === 'created_at' && subgroupStore.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="subgroupStore.sort_by === 'created_at' && subgroupStore.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('name')" 
                  :class="{'sortable col-name': true, 'active': subgroupStore.sort_by === 'name'}">
                  <span>Name &nbsp;</span>
                  <i v-if="subgroupStore.sort_by === 'name' && subgroupStore.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="subgroupStore.sort_by === 'name' && subgroupStore.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('drivers_count')" 
                  :class="{'sortable col-name': true, 'active': subgroupStore.sort_by === 'drivers_count'}">
                  <span>Drivers &nbsp;</span>
                  <i v-if="subgroupStore.sort_by === 'drivers_count' && subgroupStore.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="subgroupStore.sort_by === 'drivers_count' && subgroupStore.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th scope="col" class="col-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in paginatedData" :key="index">
                <td>{{ item.created_at }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.drivers_count }}</td>
                <td>
                  <EditSubgroupModal :subgroup="item" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分頁 -->
        <div class="pagination-wrapper">
          <div class="pagination-container">
            <button @click="changePage(1)" :disabled="currentPage === 1"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><img  src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" /></button>
            <span>
              Page
                            <input type="number" style="width: 60px;" v-model.number="currentPageInput" @change="changePage(currentPageInput)" />

              of {{ totalPages }}
            </span>
            <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(totalPages)" :disabled="currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" /></button>
          </div>
          <div class="total-count">
            Displaying subgroups {{ (currentPage - 1) * itemsPerPage + 1 }} – {{ Math.min(currentPage * itemsPerPage, totalEntries) }} of {{ totalEntries }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-results">No results found.</div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useSubgroupStore } from '@/store/admin/subgroup';
import EditSubgroupModal from './EditSubgroupModal.vue';
import { onBeforeRouteLeave } from 'vue-router';  


const subgroupStore = useSubgroupStore();

const currentPage = ref(1);
const itemsPerPage = ref(10);
const currentPageInput = ref(currentPage.value);
const subgroup_name = ref('');

// 表格排序處理邏輯
const sortTable = (field) => {
  if (subgroupStore.sort_by === field) {
    subgroupStore.order = subgroupStore.order === 'asc' ? 'desc' : 'asc';
  } else {
    subgroupStore.sort_by = field;
    subgroupStore.order = 'desc';
  }
  search();  // 重新調用API進行查詢
};

const fetchSubgroups = async () => {
  await subgroupStore.fetchSubgroups(currentPage.value, itemsPerPage.value);
};

const filterVisible = ref(false); // 控制查詢器是否顯示

const toggleFilter = () => {
  filterVisible.value = !filterVisible.value;
};


onBeforeRouteLeave(() => {
  resetState();
});

const resetState = () => {
  subgroup_name.value = '';
  subgroupStore.subgroup_name = '';
  currentPage.value = 1;
  currentPageInput.value = 1;
  itemsPerPage.value =10;
  subgroupStore.changePage(1); // 重置分页到第一页
};



const resetFilters = () => {
  subgroup_name.value ='';
  search();
};

const search = () => {
  subgroupStore.subgroup_name = subgroup_name.value;
  fetchSubgroups();
};

const paginatedData = computed(() => {
  return subgroupStore.paginatedData;
});

const totalPages = computed(() => {
  return subgroupStore.totalPages;
});

const totalEntries = computed(() => {
  return subgroupStore.totalEntries;
});

const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
    currentPageInput.value = page;
    subgroupStore.changePage(page);
  }
};

onMounted(() => {
  resetFilters();
  });
</script>

<style scoped>
.card {
  margin: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-body {
  padding: 20px;
  position: relative;
}

.no-results {
    margin: 15px;
    border-radius: 20px;
    padding: 50px;
    font-size: 20px;
    text-align: center;
    color: black;
    background-color: #ccd3da;
  }

.table-responsive {
  margin-top: 20px;
}

.table-hover tbody tr:hover {
  background-color: #f1f1f1;
}

/* 為表格欄位設定最小寬度 */
.col-name {
  min-width: 150px;
}

.table th.sortable {
  cursor: pointer;
  position: relative;
  padding-bottom: 10px;
}

.table th.sortable:hover {
  color: #00c962; /* Hover 時的文字顏色 */
}

.table th.active {
  color: #00c962; /* 當前排序的欄位文字顏色 */
}

/* 排序箭頭樣式 */
.sort-icon {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  vertical-align: middle;
}

/* 排序欄位下的綠色下劃線 */
.table th.active::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: #00c962;
  position: absolute;
  bottom: 0;
  left: 0;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
}

.pagination-container {
  display: flex;
  align-items: center;
}

.pagination-container button {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  color: #8476f4;
}

.pagination-container span {
  margin: 0 10px;
}

.pagination-container input {
  width: 50px;
  text-align: center;
}

.btn-reset {
    /* BTN_B */

    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 14px 32px;
    gap: 10px;

    width: 150px;
    height: 46px;

    /* Green */
    border: 2px solid #00C962;
    border-radius: 30px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .btn-search {
    /* BTN_A_V2 */

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 32px;
    gap: 10px;

    width: 150px;
    height: 46px;

    /* Green */
    background: #00C962;
    border-radius: 30px;

    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;
  }

  .btn-reset:hover {
    background: white;
    border: 2px solid #00b452;
  }
  .btn-search:hover {
    background: #00b452;
    border: 2px solid #00b452;
  }


.btn-green {
  margin-top: 20px;
  background-color: #00c962;
  height: 40px;
}

.filter-header {
  display: flex;
  justify-content: flex-end;
}

.btn-toggle {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.filter-toggle-icon {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 24px;
  color: #666;
  cursor: pointer;
}

.total-count {
  font-size: 16px;
  color: #666;
}

.toggle-filter {
  text-align: right;
  margin: 20px;
}

.signal-table.table-responsive .table tbody tr td:nth-child(n+2) {
  min-width: 100px !important;
}

@media (max-width: 630px) {
  .pagination-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pagination-summary {
    margin-top: 10px;
    justify-content: center;
  }

  .pagination-container {
    justify-content: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
